import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"list-box"},[_c('div',{class:'chip-list ' + _vm.alignClass},_vm._l((_vm.rubrics),function(rubric){return _c(VChip,{key:rubric.id,staticClass:"rubric-chip",attrs:{"color":"primary","link":"","outlined":"","small":""},on:{"click":function($event){return _vm.showRubric(rubric.id)}}},[_vm._v(_vm._s(_vm.getRubricFullName(rubric)))])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }